// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SENT_EMAILS_TO_USERS = 'massMailing/SENT_EMAILS_TO_USERS';

export const MASS_MAILING_FORM = {
    MESSAGE_FIELD: 'mass-mailing-message-field',
    SHOW_EXAMPLE_LINK: 'mass-mailing-show-example-link',
    ADD_EXAMPLE_BTN: 'mass-mailing-add-example-btn',
    PREVIEW_DIALOG: 'mass-mailing-preview-dialog',
    PREVIEW_SUBJECT: 'mass-mailing-preview-subject',
    PREVIEW_IFRAME: 'mass-mailing-preview-iframe',
    PREVIEW_SAMPLE_LABEL: 'mass-mailing-preview-sample-label',
    PREVIEW_ERROR: 'mass-mailing-preview-error',
    MAIL_DISABLED_ALERT: 'mass-mailing-mail-disabled-alert',
};
